import React from "react";
import { mapDeviceToDataTable as mapData } from "./Helper";
import ReusableDndTable from "src/components/table/ReusableDndTable/ReusableDndTable";
import GetDeviceColumns from "./ColumnDefinition/DeviceColumn/GetDeviceColumns";

const DeviceTable = ({
  data,
  handleDelete,
  handleShowHomePage,
  onDragEnd,
  status,
}) => {
  const columns = GetDeviceColumns({
    handleDelete,
    handleShowHomePage,
    status,
  });

  return (
    <ReusableDndTable
      columns={columns}
      data={mapData(data)}
      maxHeight={450}
      onDragEnd={onDragEnd}
    />
  );
};

export default DeviceTable;
